/** @format */

import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';
import GeoLocationStateInterface, { GeoLocationStateCollectionInterface } from '../../interfaces/platform/GeoLocationStateInterface';
import { geoLocationStateConstants } from './actions';

const _ = require('underscore');

export type LoadGeoLocationStateType = {
    callback: () => void;
    filters: Array<Filter>;
    orders: Array<Order>;
};

export class GeoLocationStateLoader {
    private itemLoaders: ItemLoaders;

    private states: GeoLocationStateCollectionInterface | null;

    private statesHeaderList: Array<HeaderCheckBoxSelectListElement> | null;

    constructor(itemLoader: ItemLoaders) {
        this.itemLoaders = itemLoader;
        this.states = null;
        this.statesHeaderList = null;
    }

    loadGeoLocationStates = (params: LoadGeoLocationStateType): void => {
        this.itemLoaders.getListWithCallback(
            FormGeneralHelper.getUrl('/geo_location_states'),
            geoLocationStateConstants.LIST,
            params.filters,
            params.orders,
            (data: GeoLocationStateCollectionInterface): void => {
                this.states = data;
                this.statesHeaderList = null;
                params.callback();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    getHeaderList = (): Array<HeaderCheckBoxSelectListElement> => {
        if (!this.statesHeaderList) {
            const list: Array<HeaderCheckBoxSelectListElement> = [];
            if (!this.states || this.states['hydra:totalItems'] === 0) {
                return list;
            }
            this.states['hydra:member'].map((item: GeoLocationStateInterface) => {
                list.push({ name: item.stateName, value: item.id });
            });
            this.statesHeaderList = list;
        }
        return this.statesHeaderList;
    };

    getItemById = (stateId: number): GeoLocationStateInterface | null => {
        if (this.states) {
            return _.find(this.states?.['hydra:member'], (item: GeoLocationStateInterface) => {
                return item.id === stateId;
            });
        }
        return null;
    };

    getName = (stateId: number): string | null => {
        const obj = this.getItemById(stateId);
        if (!obj) {
            return null;
        }
        return obj.stateName;
    };

    getIdByName = (stateName: string): number | null => {
        const obj = _.find(this.getHeaderList() ?? [], (item: HeaderCheckBoxSelectListElement) => {
            return item.name.toLowerCase() === stateName.toLowerCase();
        });

        if (!obj) {
            return null;
        }

        return obj.value;
    };
}
